// @ts-check

import Network from '../../../../infrastructure/js/modules/network';

/**
 * @typedef {import('mat/js/types/ServerTypes/Models/ItemComments').AddTaskCommentRequestModel} AddTaskCommentRequestModel
 * @typedef {import('mat/js/types/ServerTypes/Models/ItemComments').R_AddTaskCommentResult} R_AddTaskCommentResult
 * 
 * 
 * @typedef {import('mat/js/types/ServerTypes/Models/ItemComments').GetTaskCommentsRequestModel} GetTaskCommentsRequestModel
 * @typedef {import('mat/js/types/ServerTypes/Models/ItemComments').RL_TaskProgressCommentDto} RL_TaskProgressCommentDto
 * 
 * 
 * 
 * 
 */



/**
 * @param {GetTaskCommentsRequestModel} requestModel
 * 
 * @returns {Promise<RL_TaskProgressCommentDto | undefined>}
 */
export async function getTaskComments(requestModel) {
  
  let taskId = requestModel.taskId;
  if (!taskId) {
    return;
  }
  
  let networkPromise = Network.get(`planner/tasks/progress/${taskId}/comment`);
  if (!networkPromise) {
    return;
  }
  
  let result = await networkPromise;
  
  return result;
  
}



/**
 * @param {AddTaskCommentRequestModel} requestModel
 * 
 * @returns {Promise<R_AddTaskCommentResult | undefined>}
 * 
 */
export async function addTaskComment(requestModel) {

  let taskId = requestModel.taskId;
  if (!taskId) {
    return;
  }

  let networkPromise = Network.post(`planner/tasks/progress/${taskId}/comment`, requestModel);
  if (!networkPromise) {
    return;
  }
  
  let result = await networkPromise;
  
  return result;
}






